import { ScrollTriggerManager } from '../utils/gsap/scrolltrigger-manager.js'

export const initScrollTrigger = (ctx) => {
	const manager = new ScrollTriggerManager({
		refreshDelay: 25,
		debug: false,
		scrollTriggerConfig: {
			ignoreMobileResize: true,
		},
	})

	// ScrollTrigger.normalizeScroll({ allowNestedScroll: true })

	ctx.scrollTriggerManager = manager
	return manager
}
